var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.5C7.5 6.94772 7.94772 6.5 8.5 6.5H15.5C16.0523 6.5 16.5 6.94772 16.5 7.5V9.5C16.5 10.0523 16.0523 10.5 15.5 10.5H8.5C7.94772 10.5 7.5 10.0523 7.5 9.5V7.5ZM8.5 7.5H15.5V9.5H8.5V7.5Z",
    fill: "#3E3D3D",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 20.6244L3.50357 20.6204C3.56583 21.6689 4.43586 22.5 5.5 22.5H19.5V21.5H5.5C4.94772 21.5 4.5 21.0523 4.5 20.5C4.5 19.9477 4.94772 19.5 5.5 19.5H18.5C19.2403 19.5 19.8866 19.0978 20.2324 18.5C20.4026 18.2058 20.5 17.8643 20.5 17.5V5.5C20.5 4.39543 19.6046 3.5 18.5 3.5H5.5C4.39543 3.5 3.5 4.39543 3.5 5.5V20.6244ZM18.5 4.5H5.5C4.94771 4.5 4.5 4.94771 4.5 5.5V18.6375C4.78765 18.5473 5.0901 18.5 5.39783 18.5H18.5C19.0523 18.5 19.5 18.0523 19.5 17.5V5.5C19.5 4.94772 19.0523 4.5 18.5 4.5Z",
    fill: "#3E3D3D",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsIcon);
export default __webpack_public_path__ + "static/media/materialsIcon.321296315fe3854952b88741dfeda8db.svg";
export { ForwardRef as ReactComponent };